<template>
    <div class="m-no-results">
        <img src="/assets/img/no-results.png" alt="No results" class="m-no-results__image" />
        <h2 class="u-heading-secondary">Ah sugar...</h2>
        <p>Your search returned no results. Please try another search term, check the spelling, or use our menu to filter items.</p>
        <p v-if="suggestions.length">You may like our products in these other categories:</p>
        <p class="m-no-results__suggestions" v-if="suggestions.length">
            <a :href="suggestion.url" class="c-tag" v-for="suggestion in suggestions">
                {{ suggestion.name }}
            </a>
        </p>
    </div>
</template>

<script>
    import searchStore from "../stores/search.js";

    export default {
        data: function () {
            return {
                suggestions: []
            }
        },
        methods: {
            loadSuggestions: function () {
                searchStore.autocomplete().then(res => {
                    this.suggestions = res.data;
                });
            }
        },
        mounted: function () {
            this.loadSuggestions();
        }
    }
</script>